import { useEffect } from "react";
import { MutableRefObject } from "react";

export default function useOnClickOutside(elementRef: MutableRefObject<HTMLDivElement>, handleOutsideClick: Function) {
  useEffect(() => {
    document.addEventListener("click", (event) => {
      if (elementRef.current && !elementRef?.current?.contains(event.target as Node)) {
        handleOutsideClick();
      } else return;
    });
  }, []);
}
